import React, { FC, useCallback, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { PrintModal } from '../printModal';
import config from 'config';

export const SingleFlowerView: FC<Record<string, unknown>> = () => {
  const history = useHistory();
  const { flowerId } = useParams<{
      flowerId: string;
    }>();

  const [show, setShow] = useState<boolean>(true);

  const onClose = useCallback(
    () => {
      setShow(false);
      history.push({
        pathname: config.url.flowersTraking,
      });
    },
    [history],
  );

  return (
    <div>
      {flowerId && (
      <PrintModal
        id={parseInt(flowerId, 10)}
        show={show}
        onHide={onClose}
      />
      )}
    </div>
  );
};
